import { addDays, addMonths, format } from "date-fns"
import { ptBR } from "date-fns/locale"

  export function Calendar(e) {
    let Months = []
    for (let i = 0; i < e.length; i++) {
      const MonthsAux = addMonths(addDays(new Date(Number(e[i].ano), Number(e[i].mes)), 0), -1)
      const MonthsAux2 = format(MonthsAux, "MMMM", { locale: ptBR })
      Months.push(MonthsAux2)
    }
    return Months
  }

  export function CompareNumbers(a, b) {
    const mes_a = a.mes_ano.split("/")
    const mes_b = b.mes_ano.split("/")
    return mes_a[0] - mes_b[0] + (mes_a[1] - mes_b[1]) * 100;
  }